import { useEffect, useState } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { api } from "@/lib/api";
import { useCurrency } from "@/lib/CurrencyProvider";
import { Link } from "react-router-dom";
import { Stethoscope } from "lucide-react";

export default function Services() {
  const [services, setServices] = useState([]);
  const [filter, setFilter] = useState("All");
  const { format } = useCurrency();

  useEffect(() => { api.get("/services").then((r) => setServices(r.data)); }, []);

  const cats = ["All", ...Array.from(new Set(services.map((s) => s.category)))];
  const filtered = filter === "All" ? services : services.filter((s) => s.category === filter);

  return (
    <div className="min-h-screen ankara" data-testid="services-page">
      <Header />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 md:pt-20 pb-10">
        <div className="chip chip-emerald mb-3">Our services</div>
        <h1 className="font-display text-4xl md:text-6xl leading-[1.05]">Every service your pet <span className="italic text-[#C2410C]">could ever need.</span></h1>
        <p className="mt-6 max-w-2xl text-[#57534E]">Veterinary consultations, vaccinations, deworming, health check-ups, breeding support, and home visits (where available). All prices in Nigerian Naira.</p>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="flex flex-wrap gap-2 mb-8" data-testid="service-filters">
          {cats.map((c) => (
            <button key={c} onClick={() => setFilter(c)} data-testid={`filter-${c}`}
              className={`px-4 py-2 rounded-full text-xs font-semibold border transition-colors ${filter === c ? "bg-[#0F766E] text-white border-[#0F766E]" : "bg-white text-[#1C1917] border-[#EAD9B0] hover:border-[#0F766E]"}`}>
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((s) => (
            <div key={s.service_id} className="card-lift bg-white border border-[#EAD9B0] rounded-2xl p-6" data-testid={`service-${s.service_id}`}>
              <div className="flex items-center justify-between">
                <div className="h-10 w-10 rounded-xl bg-[#0F766E]/10 flex items-center justify-center"><Stethoscope size={18} className="text-[#0F766E]" /></div>
                <div className="flex gap-2">
                  <span className="chip chip-gold">{s.category}</span>
                  {s.mode === "virtual" && <span className="chip chip-terra">Online</span>}
                </div>
              </div>
              <div className="mt-4 font-display text-xl">{s.name}</div>
              <p className="mt-2 text-sm text-[#57534E] leading-relaxed">{s.description}</p>
              <div className="mt-5 flex items-center justify-between">
                <span className="text-xs text-[#57534E]">{s.duration_min} min</span>
                <span className="font-semibold text-[#0F766E]">{s.price_display || format(s.price)}</span>
              </div>
              <Link to={s.category === "Livestock" ? "/farm-visit" : "/book"} state={{ preselectService: s.service_id }} className="mt-5 block text-center btn-primary rounded-full py-2.5 text-sm font-semibold" data-testid={`book-${s.service_id}`}>
                {s.category === "Livestock" ? "Request farm visit" : "Book this service"}
              </Link>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
